<template>
  <div>
    <Bar text="企业信息"></Bar>
    <div class="e-flex jc-center mt-6">
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        style="width: 600px"
        label-width="140px"
      >
      <el-form-item
      label="保函形式"
      prop="exectronic"
    >
      <el-radio-group v-model="form.exectronic" @change="elRadioGroup">
        <el-radio label="1">电子-保险投标保函</el-radio>
        <el-radio label="0">纸质-保险投标保函</el-radio>
      </el-radio-group>
    </el-form-item>
        <el-form-item label="投标人名称" prop="bidderCompanyName">
          <el-input
            v-model="form.bidderCompanyName"
            placeholder="请填写企业（投标人）全称"
          />
        </el-form-item>
        <el-form-item :label="'企业办公地址'+(isElectronicIns?'':'（同保函邮寄地址）')" :prop="isElectronicIns?'':'bidderLinkAdress'">
          <el-input
            v-model="form.bidderLinkAdress"
            placeholder="请填写企业详细地址用于快递或票务"
          />
        </el-form-item>
        <el-form-item label="统一社会信用代码" :prop="isElectronicIns?'':'bidderSocialCreditCode'">
          <el-input
            v-model="form.bidderSocialCreditCode"
            placeholder="请填写统一社会信用代码"
          />
        </el-form-item>
        <el-form-item label="联系人" prop="bidderLinkName">
          <el-input
            v-model="form.bidderLinkName"
            placeholder="请填写保函申请人姓名"
          />
        </el-form-item>
        <el-form-item label="联系方式" prop="bidderMobilePhone">
          <el-input
            v-model="form.bidderMobilePhone"
            placeholder="请填写保函申请人手机号码 "
          />
        </el-form-item>
        <!-- <el-form-item label="邮箱" prop="bidderLinkMail">
          <el-input
            v-model="form.bidderLinkMail"
            placeholder="请填写邮箱用于接受电子保单文件信息 "
          />
        </el-form-item> -->
        <el-form-item label="上传营业执照" prop="businessLicense">
          <UP
            actionUrl="/zcjf/base/file/upload"
            uploadTitle="上传营业执照"
            @fileIdCb="businessLicenseUploadSuccess"
            :fileId="form.businessLicense"
            accept =".pdf, .doc, .docx, .rar, .zip, .jpg, .bmp, .gif, .png, .jpeg"
          >
            <template #explain>
              <ul slot="tip" class="el-upload__tip">
                <li>请上传营业执照副本扫描件，支持PDF、WORD、RAR、ZIP、JPG、BMP、GIF、PNG、JPEG文档</li>
              </ul>
            </template></UP
          >
        </el-form-item>
        <el-form-item label="法定代表人身份证" prop="legalRepresentativeIdCard" v-if="form.exectronic === '1'">
          <UP
            actionUrl="/zcjf/base/file/upload"
            uploadTitle="上传身份证"
            @fileIdCb="legalRepresentativeIdCardUploadSuccess"
            :fileId="form.legalRepresentativeIdCard"
            accept =".pdf, .doc, .docx, .rar, .zip, .jpg, .bmp, .gif, .png, .jpeg"
          >
            <template #explain>
              <ul slot="tip" class="el-upload__tip">
                <li>请上传法定代表人身份证扫描件，支持PDF、WORD、RAR、ZIP、JPG、BMP、GIF、PNG、JPEG文档</li>
              </ul>
            </template></UP
          >
        </el-form-item>
        <el-form-item label="是否需邮寄纸质保函" prop="mailPaperGuarantee" v-if="form.exectronic === '0'">
          <el-radio-group v-model="form.mailPaperGuarantee"  size="medium">
            <el-radio-button label="0">是</el-radio-button>
            <el-radio-button label="1">否</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item :wrapper-col="{ span: 14, offset: 4 }">
          <el-button plain v-if="!$route.query.orderID" @click="saveDraft" :loading="draftSaving">保存</el-button>
          <el-button type="primary" @click="onSubmit" class="elBtn">
            下一步
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import {
  mapMutations,
  mapState,
  INSURANCE,
} from '../../../store/modules/insurance'
import { cloneDeep } from 'lodash'
import bar from '../projectBar/bar'
import { bidderMobilePhonePass, bidderLinkMailPass } from '@/shared/validate'
import uploadE from '../../../common/upload/uoload.vue'
import { ORDER_TYPE, saveCurrentDraft } from '@/shared/guaranteeDraft'
export default {
  watch: {
    'form.businessLicense': function(newVal, oldVal) {
      if (newVal) {
        if (this.$refs.isFile) this.$refs.isFile.clearValidate()
      }
    },
  },

  data() {
    const businessLicensePass = (rule, value, callback) => {
      if (this.form.businessLicense) {
        callback()
      } else {
        callback(new Error('请上传营业执照'))
      }
    }
    const legalRepresentativeIdCardPass = (rule, value, callback) => {
      if (this.form.legalRepresentativeIdCard) {
        callback()
      } else {
        callback(new Error('请上传法定代表人身份证'))
      }
    }
    return {
      form: {
        exectronic: '1',
      },
      draftSaving: false,

      rules: {
        mailPaperGuarantee: {
          required: true,
          message: '请选择是否需要邮寄纸质保函',
          trigger: 'change',
        },
         exectronic: {
          required: true,
          message: '请选择保函形式',
          trigger: 'change',
        },
        businessLicense: [
          {
            required: true,
            trigger: 'change',
            validator: businessLicensePass,
          },
        ],
        legalRepresentativeIdCard: [
          {
            required: true,
            trigger: 'change',
            validator: legalRepresentativeIdCardPass,
          },
        ],
        bidderLinkMail: [
          {
            required: true,
            trigger: 'change',
            validator: bidderLinkMailPass,
          },
        ],
        bidderCompanyName: [
          { required: true, message: '请填写企业名称', trigger: 'change' },
        ],
        bidderLinkAdress: {
          required: true,
          message: '请填写企业地址',
          trigger: 'change',
        },
        bidderSocialCreditCode: {
          required: true,
          message: '请填写统一社会信用代码',
          trigger: 'change',
        },
        bidderMobilePhone: [
          {
            required: true,
            trigger: 'change',
            validator: bidderMobilePhonePass,
          },
        ],
        bidderLinkName: [
          { required: true, message: '请填写联系人', trigger: 'change' },
        ],
      },
    }
  },

  computed: {
    ...mapState({
      formStorage: 'insurance',
    }),
    //判断是否为电子保险保函
    isElectronicIns() {
      return this.form.exectronic === '1'
    },
  },
  beforeMount() {
    // step 切换恢复：从 Vuex insurance 读（父组件 init(data) 在 nextTick 后覆盖为最新值）
    const { formStorage } = this
    this.form = cloneDeep(formStorage || {})
    if (!this.form.exectronic) {
      this.$set(this.form, 'exectronic', this.form.isExectronic ? this.form.isExectronic : '1')
    }
  },
  components: {
    Bar: bar,
    UP: uploadE,
  },
  methods: {
    ...mapMutations({
      in: INSURANCE.INSURANCE,
    }),
    businessLicenseUploadSuccess(res) {
      this.form.businessLicense = res.url
      this.$refs.form.validateField('businessLicense')
    },
    legalRepresentativeIdCardUploadSuccess(res) {
      this.form.legalRepresentativeIdCard = res.url
      this.$refs.form.validateField('legalRepresentativeIdCard')
    },
    init(data) {
      this.form = cloneDeep(data || {})
      this.$set(this.form, 'exectronic', this.form.isExectronic?this.form.isExectronic:'0')
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (!valid) return
        this.$emit('changeIndex', 1)
        this.in(this.form)
      })
    },
    async saveDraft() {
      this.draftSaving = true
      try {
        await saveCurrentDraft(this, ORDER_TYPE.INSURANCE_7000, 0, this.form)
      } finally {
        this.draftSaving = false
      }
    },
    elRadioGroup() {
      this.$refs.form.clearValidate()
    },
  },
}
</script>
